import { Expose } from "class-transformer";
import { IsString } from "class-validator";

export class ConnectorSettings {
  @IsString()
  @Expose()
  login!: string;
  @IsString()
  @Expose()
  password!: string;
  @IsString()
  @Expose()
  connectorLoginUrl!: string;
  @IsString()
  @Expose()
  connectorRegisterUrl!: string;
  @IsString()
  @Expose()
  connectorRestServiceUrl!: string;
  @IsString()
  @Expose()
  connectorListenerServiceEIStatusUrl!: string;
  @IsString()
  @Expose()
  connectorListenerServiceUrl!: string;
}
